import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { SharedHttp } from "../../../services/http-client.service";
import { LanguageService } from "../../../services/language.service";
let BankaccountWhitelistInfoComponent = class BankaccountWhitelistInfoComponent {
    constructor(sanitizer, location, themeService, httpClient, languageService) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.languageService = languageService;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.buttonClicked = false;
        this.url = '';
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.location.onPopState(() => {
            this.close();
        });
        this.url = window.location.href + '?action=fiatwithdrawal';
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    goToBlinking() {
        this.buttonClicked = true;
        this.httpClient.post('blinking/initiateBankAccountProcess', { languageCode: this.lang, redirectUrl: this.url }).subscribe((data) => {
            this.close();
            window.open(data['url'], '_self');
        }, (error) => {
            this.buttonClicked = false;
        });
    }
};
BankaccountWhitelistInfoComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: LanguageService }
];
BankaccountWhitelistInfoComponent = __decorate([
    Component({
        selector: 'app-bankaccount-whitelist-info',
        template: __importDefault(require("./bankaccount-whitelist-info.component.html")).default,
    })
], BankaccountWhitelistInfoComponent);
export { BankaccountWhitelistInfoComponent };
